import React, {useRef, useState} from "react"
import Wave from 'react-wavify'
import '../styles/contactsection.css';
import 'react-notifications/lib/notifications.css';
import emailjs from '@emailjs/browser';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { useInView } from '../hooks/useInView';
import GithubLogo from '../img/githublink.png'
import LinkedInLogo from '../img/linkedinlink.png'
import EmailLogo from '../img/maillink.png'

const ContactSection = () => {
    const form = useRef();
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [message, setMessage] = useState("");

    const { ref: titleRef, inView: titleInView } = useInView();
    const { ref: messageRef, inView: messageInView } = useInView();
    const { ref: nameInputRef, inView: nameInputInView } = useInView();
    const { ref: emailInputRef, inView: emailInputInView } = useInView();
    const { ref: textareaRef, inView: textareaInView } = useInView();
    const { ref: submitRef, inView: submitInView } = useInView();
    const { ref: githubRef, inView: githubInView } = useInView();
    const { ref: linkedinRef, inView: linkedinInView } = useInView();
    const { ref: emailRef, inView: emailInView } = useInView();

    const sendEmail = (e) => {
        e.preventDefault();
        NotificationManager.success(`Talk to you soon ${userName}`, 'Message Sent!');
        setUserName("");
        setUserEmail("");
        setMessage("");
        emailjs.sendForm('service_2jlu9m5', 'template_gzss75t', form.current, 'TXhxWBs3iH2XOXiqJ')
          .then((result) => {
          }, (error) => {
          })
    };

    return(
        <React.Fragment>
            <div id="contact">
                <h1 ref={titleRef} className={`section-title fade-in-left ${titleInView ? 'animation-active' : ''}`}>
                    Contact
                </h1>
                <p ref={messageRef} className={`contact-message fade-in ${messageInView ? 'animation-active' : ''}`}>
                    Feel free to send me a message!
                </p>
                <form ref={form} className="contact-form" onSubmit={sendEmail}>
                    <div className="input-row">
                        <input
                            ref={nameInputRef}
                            className={`input-box fade-in-left ${nameInputInView ? 'animation-active' : ''}`}
                            type="text"
                            placeholder="Your name"
                            name="user_name"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-row">
                        <input
                            ref={emailInputRef}
                            className={`input-box fade-in-left ${emailInputInView ? 'animation-active' : ''}`}
                            type="email"
                            placeholder="Your Email"
                            name="user_email"
                            value={userEmail}
                            onChange={(e) => setUserEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-row">
                        <textarea
                            ref={textareaRef}
                            className={`input-text-area fade-in-left ${textareaInView ? 'animation-active' : ''}`}
                            placeholder="Message"
                            name="message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-row">
                        <button
                            ref={submitRef}
                            className={`contact-submit-button fade-in-up hover-scale-lg ${submitInView ? 'animation-active' : ''}`}
                            type="submit"
                        >
                            SEND
                        </button>
                    </div>
                    <NotificationContainer/>
                </form>
                <div className="navbar-spacer"><p></p></div>
                <Wave className="wave" fill='#fefcbf' paused={false}
                    options={{
                        height: 20,
                        amplitude: 20,
                        speed: 0.20,
                        points: 3
                    }}
                />
                <div className="contact-links">
                    <a
                        ref={githubRef}
                        title="github.com/dellod"
                        className={`contact-link fade-in-up hover-scale-lg ${githubInView ? 'animation-active' : ''}`}
                        href="https://github.com/dellod"
                        target="_blank"
                        rel="noreferrer">
                        <img className="contact-link-logo" src={GithubLogo} alt="github" />
                    </a>
                    <a
                        ref={linkedinRef}
                        title="linkedin.com/in/darylvdang/"
                        className={`contact-link fade-in-up hover-scale-lg ${linkedinInView ? 'animation-active' : ''}`}
                        href="https://www.linkedin.com/in/darylvdang/"
                        target="_blank"
                        rel="noreferrer">
                        <img className="contact-link-logo" src={LinkedInLogo} alt="linkedin" />
                    </a>
                    <a
                        ref={emailRef}
                        title="darylvdang@gmail.com"
                        className={`contact-link fade-in-up hover-scale-lg ${emailInView ? 'animation-active' : ''}`}
                        href="mailto:darylvdang@gmail.com"
                        target="_blank"
                        rel="noreferrer">
                        <img className="contact-link-logo" src={EmailLogo} alt="email" />
                    </a>
                </div>
                <div className="acknowledgement-section">
                    <p className="acknowledgement-text">Icons by <a href="https://icons8.com/">Icons8</a></p>
                </div>
            </div>
        </React.Fragment>
    );
}

export default ContactSection;